import script from "./BatchDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchDetails.vue?vue&type=script&setup=true&lang=ts"

import "./BatchDetails.vue?vue&type=style&index=0&id=89998db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89998db0"]])

export default __exports__